// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2p-values-format .tag-item{margin-right:10px}.d2p-values-format>span{margin-right:5px}", ""]);
// Exports
module.exports = exports;
